function init_header_cta() {
    $(document).on('scroll', function() {
        check_header_cta_visible();
    });

    $(window).on('resize', function(){
        check_header_cta_visible();
    });
}

function check_header_cta_visible() {
    var screen_width = $(window).width();

    // Only do stuff when the screen is smaller than 400px. The button is not hidden on larger screens, so there is no need for checking.
    if(screen_width <= 400) {
        var scrolled_distance_from_top = $(document).scrollTop();
        var $header = $('.header');
        var header_height = $header.height();
        var $target_button = $('.mobile-sticky-cta .cpx-button:first-child');

        if(scrolled_distance_from_top > header_height) {
            $target_button.addClass('first-button-visible');
        }
        else {
            $target_button.removeClass('first-button-visible');
        }
    }
}

$(document).ready(function() {
    init_header_cta();
});